<template>
    <div v-if="isCustomerLoaded()">
        <b-modal
            v-model="showModalLocal"
            :title="'Просмотр заказчика #' + customer.id + ' ' + customerFullname(customer)"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <table class="table table-sm table-bordered table-hover">

                <tr>
                    <td style="width:50%">Менеджер</td>
                    <td style="width:50%" v-if="customer.user_id">{{ customer.user.surname }} {{ customer.user.name_ }} {{ customer.user.patro }}</td>
                    <td style="width:50%" v-else>не назначен</td>
                </tr>

                <tr>
                    <td style="width:50%">ФИО</td>
                    <td style="width:50%">{{customer.surname}} {{customer.name}} {{customer.patro}}</td>
                </tr>

                <tr v-if="customer.email">
                    <td style="width:50%">E-mail</td>
                    <td style="width:50%"><a :href="'mailto:'+customer.email">{{customer.email}}</a></td>
                </tr>

                <tr v-if="customer.tel">
                    <td style="width:50%">Телефон</td>
                    <td style="width:50%"><a :href="'tel:'+customer.tel">{{customer.tel}}</a></td>
                </tr>

                <tr v-for="telenum in customer.telenums">
                    <td style="width:50%">Телефон</td>
                    <td style="width:50%"><a :href="'tel:'+telenum.number">{{telenum.number}}</a>
                        <template v-if="telenum.info"><small> &nbsp; {{telenum.info}}</small></template>
                    </td>
                </tr>

                <tr v-if="customer.country">
                    <td style="width:50%">Страна</td>
                    <td style="width:50%">{{customer.country.title_ru}}</td>
                </tr>

                <tr v-if="customer.city">
                    <td style="width:50%">Город</td>
                    <td style="width:50%">{{customer.city}}</td>
                </tr>

                <tr v-if="customer.mail_address">
                    <td style="width:50%">Адрес почтовый</td>
                    <td style="width:50%">{{customer.mail_address}}</td>
                </tr>

                <template v-if="!customer.is_org">
                    <tr v-if="customer.passport">
                        <td style="width:50%">Адрес</td>
                        <td style="width:50%">{{customer.passport}}</td>
                    </tr>
                </template>

                <template v-if="customer.is_org">


                    <tr v-if="customer.org_name">
                        <td style="width:50%">Наименование</td>
                        <td style="width:50%">{{customer.org_name}}</td>
                    </tr>

                    <tr v-if="customer.org_addr">
                        <td style="width:50%">Адрес юридического лица</td>
                        <td style="width:50%">{{customer.org_addr}}</td>
                    </tr>

                    <tr v-if="customer.org_inn">
                        <td style="width:50%">ИНН/КПП</td>
                        <td style="width:50%">{{customer.org_inn}}/{{customer.org_kpp}}</td>
                    </tr>

                    <tr v-if="customer.org_inn">
                        <td style="width:50%">ОГРН</td>
                        <td style="width:50%">{{customer.org_inn}}</td>
                    </tr>

                    <tr v-if="customer.org_rs">
                        <td style="width:50%">Расчетный счет</td>
                        <td style="width:50%">{{customer.org_rs}}</td>
                    </tr>

                    <tr v-if="customer.org_ks">
                        <td style="width:50%">К/С</td>
                        <td style="width:50%">{{customer.org_ks}}</td>
                    </tr>

                    <tr v-if="customer.org_bik">
                        <td style="width:50%">БИК</td>
                        <td style="width:50%">{{customer.org_bik}}</td>
                    </tr>

                    <tr v-if="customer.org_bank">
                        <td style="width:50%">Банк</td>
                        <td style="width:50%">{{customer.org_bank}}</td>
                    </tr>

                    <tr v-if="customer.org_manager_position">
                        <td style="width:50%">Должность подписанта</td>
                        <td style="width:50%">{{customer.org_manager_position}}</td>
                    </tr>

                    <tr v-if="customer.org_manager">
                        <td style="width:50%">ФИО Подписанта</td>
                        <td style="width:50%">{{customer.org_manager}}</td>
                    </tr>

                    <tr v-if="customer.org_manager_genetive">
                        <td style="width:50%">ФИО Подписанта в родительном падеже</td>
                        <td style="width:50%">{{customer.org_manager_genetive}}</td>
                    </tr>

                    <tr v-if="customer.org_manager_document">
                        <td style="width:50%">На основании чего действует подписант</td>
                        <td style="width:50%">{{customer.org_manager_document}}</td>
                    </tr>

                </template>
            </table>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_customers } from '@/functions_customers.js';

    export default {
        name: 'ShowCustomerDialog',
        mixins: [functions, functions_customers],
        data: function () {
            return {
                extra: {
                    password: '******'
                }
            };
        },
        model: {
            prop: "customer_id",
            event: "hide"
        },
        props: {
            customer_id: [Number],
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return !!this.customer_id
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            if (this.customer_id) {
                this.resetCustomer().loadCustomer(this.customer_id);
            }
        },
    }
</script>
